<template>
  <o-view :has-white-background="true" :no-scroll="true">
    <o-view :bottom-padding="true">
      <o-nav-bar
        title="Cambio"
        :has-back-button="true"
        :has-close-button="true"
        :is-overlay="true"
      />
      <o-map :markers="markers" />
      <o-section-header title="Reservatie wijzigen">
        <template #right>
          <o-icon
            icon="support2"
            @click.native="showOverlay('supportOverlay')"
          />
          <o-icon icon="info" @click.native="showOverlay('infoOverlay')" />
        </template>
      </o-section-header>
      <o-cambio-reservation-form
        :edit="true"
        @editTime="showOverlay('tijd')"
        @editLocation="showOverlay('location')"
        @editStand="showOverlay('location')"
        @standInfo="showStandInfo"
        @editKlasse="showOverlay('klasse')"
        @klasseInfo="showKlasseInfo"
        @editDistance="showOverlay('distance')"
        @editOptions="showOverlay('options')"
        @cancel="showOverlay('cancel')"
      />
    </o-view>
    <o-overlay title="Tijd wijzigen" ref="tijd">
      <template #form>
        <o-edit-time />
      </template>
      <o-button
        label="Wijziging bevestigen"
        :is-primary="true"
        @click="hideOverlay('tijd')"
      />
    </o-overlay>
    <o-overlay title="Locatie" ref="location">
      <template #form>
        <o-edit-location-stand />
      </template>
      <o-button
        label="Wijziging bevestigen"
        :is-primary="true"
        @click="$router.push('/sales/car/cambio/reservations/edit-summary')"
      />
    </o-overlay>
    <o-overlay title="Wagenklasse" ref="klasse">
      <template #form>
        <o-edit-klasse
          @click.native="
            $router.push('/sales/car/cambio/reservations/edit-summary')
          "
        />
      </template>
    </o-overlay>
    <o-overlay title="Opties en toebehoren" ref="options">
      <template #form>
        <o-edit-options />
      </template>
      <o-button
        label="Wijziging bevestigen"
        :is-primary="true"
        @click="$router.push('/sales/car/cambio/reservations/edit-summary')"
      />
    </o-overlay>
    <o-overlay title="Rijkweidte" ref="distance">
      <template #form>
        <o-edit-distance />
      </template>
      <o-button
        label="Wijziging bevestigen"
        :is-primary="true"
        @click="$router.push('/sales/car/cambio/reservations/edit-summary')"
      />
    </o-overlay>
    <o-overlay ref="infoOverlay">
      <p>
        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut consectetur
        accumsan libero. Nullam quis elit at metus viverra tempor. Vivamus metus
        magna, dapibus at lacus et, tincidunt cursus tellus.
      </p>
    </o-overlay>
    <o-overlay title="Support" ref="supportOverlay">
      <div class="c-bottom-overlay__list">
        <o-list-item
          icon="link"
          label="Meest gestelde vragen"
          :chevron="false"
        />
      </div>
    </o-overlay>
    <o-overlay title="Reservatie annuleren" ref="cancel">
      <p>Ben je zeker dat je deze reservatie wil annuleren?</p>
      <o-button
        label="Annulatie bevestigen"
        :is-primary="true"
        @click="cancelReservation"
      />
    </o-overlay>
  </o-view>
</template>

<script>
import OCambioReservationForm from '@/components/OCambioReservationForm.vue'
import OMap from '@/components/OMap.vue'
import OPayButton from '@/components/OPayButton.vue'
import OOverlay from '@/components/base/OOverlay.vue'
import OEditTime from '@/components/overlays/OEditTime.vue'
import OEditStand from '@/components/overlays/OEditStand.vue'
import OEditOptions from '@/components/overlays/OEditOptions.vue'
import OEditKlasse from '@/components/overlays/OEditKlasse.vue'
import OEditDistance from '@/components/overlays/OEditDistance.vue'
import OEditLocationStand from '@/components/overlays/OEditLocationStand.vue'
export default {
  name: 'CambioEdit',
  components: {
    OEditLocationStand,
    OEditDistance,
    OEditKlasse,
    OEditOptions,
    OEditStand,
    OEditTime,
    OOverlay,
    OCambioReservationForm,
    OMap,
    OPayButton
  },
  data() {
    return {
      showInfoOverlay: false,
      showSupportOverlay: false,
      markers: [
        {
          coordinates: [3.715, 51.05],
          type: 'cambio',
          title: 'Cambio A',
          link: 'poi/cambio'
        },
        {
          coordinates: [3.723, 51.053],
          type: 'cambio',
          title: 'Cambio B',
          link: 'poi/cambio'
        },
        {
          coordinates: [3.72, 51.055],
          type: 'cambio',
          title: 'Cambio C',
          link: 'poi/cambio'
        }
      ]
    }
  },

  methods: {
    cancelReservation() {
      this.$router.push({ name: 'providerscambioreservations' })
    },

    showStandInfo() {
      this.$router.push({ name: 'providerscambiostandinfo' })
    },

    showKlasseInfo() {
      this.$router.push({ name: 'providerscambioclassinfo' })
    }
  }
}
</script>

<style lang="scss"></style>
